import { Box } from "@mui/material";
import React from "react";
import { useState } from "react";

import ThreeDotsMenu from "assets/Icons/replenishment/ThreeDots.svg";
import ExpandedMenu from "components/Table/components/ExpandedMenu";

export const SpanStyle = {
  position: "absolute",
  top: "-40px",
  zIndex: 2,
  left: "0px",
  right: "0px",
  margin: "0 auto",
};

const TableMenu = ({
  disableUpload,
  widgetName,
  disableExpand,
  callback,
}: {
  disableUpload?: boolean;
  widgetName?: string;
  disableExpand?: boolean;
  callback?: Function;
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [uploadState, setUploadState] = useState(false);

  const onMouseEnterHandler = () => {
    setIsHovered(true);
  };

  const onMouseLeaveHandler = () => {
    setIsHovered(false);
    if (uploadState) setIsHovered(true);
  };

  const getState = (state: boolean) => {
    setUploadState(state);
  };

  return (
    <Box onMouseEnter={onMouseEnterHandler} onMouseLeave={onMouseLeaveHandler}>
      {/* <ExpandedMenu
        disableUpload={disableUpload}
        widgetName={widgetName}
        disableExpand={disableExpand}
      /> */}
      {isHovered ? (
        <ExpandedMenu
          disableUpload={disableUpload}
          widgetName={widgetName}
          disableExpand={disableExpand}
          getState={getState}
          callback={callback}
        />
      ) : (
        <img
          src={ThreeDotsMenu}
          alt="dots"
          style={{
            position: "absolute",
            top: "-20px",
            left: 0,
            right: 0,
            margin: " 0 auto",
            cursor: "pointer",
          }}
        />
      )}
    </Box>
  );
};

export default TableMenu;
